import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Window = (props: Icon): React.ReactElement => {
  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33333 4H18.6667V17.3333H5.33333V4ZM4.66667 18.6667H19.3333C19.7 18.6667 20 18.9667 20 19.3333C20 19.7 19.7 20 19.3333 20H4.66667C4.3 20 4 19.7 4 19.3333C4 18.9667 4.3 18.6667 4.66667 18.6667ZM11.3333 15.3333H7.33333V11.3333H11.3333V15.3333ZM7.33333 10H11.3333V6H7.33333V10ZM16.6667 15.3333H12.6667V11.3333H16.6667V15.3333ZM12.6667 10H16.6667V6H12.6667V10Z"
      />
    </svg>
  );
};
